// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"6c5ceac5","510":"310b7fb9","541":"75ae23c6"}[chunkId] + ".chunk.js";
};